import { useMemo } from 'react';

interface IOn3PlusProps extends React.SVGProps<SVGSVGElement> {
  // ... any other non-svg props
  dark?: boolean;
  colors?: string[];
}

export const On3Plus = ({
  dark = false,
  colors,
  className,
  ...svgProps
}: IOn3PlusProps) => {
  const fill = useMemo(
    () =>
      colors ? colors : dark ? ['#70ED69', '#fff'] : ['#1D252C', '#70ED69'],
    [dark, colors],
  );

  return (
    <svg
      className={className}
      fill="none"
      height="16"
      viewBox="0 0 45 16"
      width="45"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M11.0972 10.6824C10.9091 11.2941 10.627 11.8118 10.2038 12.2353C9.78057 12.6588 9.31035 12.9882 8.65204 13.2235C8.04075 13.4588 7.2884 13.6 6.44201 13.6H4.9373C4.09091 13.6 3.33856 13.4588 2.68025 13.2235C2.06897 12.9882 1.55172 12.6588 1.12853 12.2353C0.705329 11.8118 0.470219 11.2941 0.282132 10.6824C0.0940439 10.0706 0 9.41176 0 8.65882V6.87059C0 6.11765 0.0940439 5.45882 0.282132 4.84706C0.470219 4.23529 0.752351 3.71765 1.17555 3.29412C1.55172 2.82353 2.06897 2.49412 2.72727 2.25882C3.33856 2.02353 4.09091 1.92941 4.98433 1.92941H6.48903C7.33542 1.92941 8.08778 2.02353 8.69906 2.25882C9.31035 2.49412 9.82759 2.82353 10.2508 3.24706C10.674 3.67059 10.9561 4.18824 11.1442 4.8C11.3323 5.41176 11.4263 6.07059 11.4263 6.82353V8.61176C11.4263 9.41176 11.3323 10.0706 11.0972 10.6824ZM2.53919 11.2941C2.96238 11.8118 3.71473 12.0471 4.74922 12.0471H6.72414C7.75862 12.0471 8.51097 11.8118 8.93417 11.2941C9.35737 10.7765 9.59248 10.0235 9.59248 9.03529V6.4C9.59248 5.36471 9.35737 4.61176 8.93417 4.14118C8.51097 3.62353 7.75862 3.38824 6.72414 3.38824H4.74922C3.71473 3.38824 3.0094 3.62353 2.53919 4.14118C2.11599 4.65882 1.88088 5.41176 1.88088 6.44706V9.08235C1.88088 10.0706 2.11599 10.8235 2.53919 11.2941Z"
        fill={fill[0]}
      />
      <path
        d="M21.395 13.7882C20.9248 13.7882 20.5016 13.647 20.2194 13.4117C19.9373 13.1764 19.6552 12.847 19.4201 12.4706L15.5643 6.25879C15.4702 6.11761 15.4232 6.0235 15.3762 5.97644C15.3762 5.92938 15.3291 5.92938 15.2821 5.92938C15.1881 5.92938 15.1881 5.97644 15.1881 5.97644C15.1411 6.0235 15.1411 6.11761 15.1411 6.21173V13.6941H13.4012V6.21173C13.4012 5.64702 13.5423 5.17644 13.8244 4.79997C14.1066 4.37644 14.5768 4.1882 15.2351 4.1882C15.7053 4.1882 16.0815 4.32938 16.3636 4.61173C16.6458 4.84703 16.9279 5.2235 17.21 5.69408L21.0188 11.8117C21.0658 11.9058 21.1599 12 21.2069 12.047C21.2539 12.0941 21.2539 12.0941 21.3009 12.0941C21.348 12.0941 21.348 12.0941 21.395 12.047C21.442 12 21.442 11.9529 21.442 11.8588V4.32938H23.1818V11.8117C23.1818 12.3764 23.0408 12.847 22.7586 13.1764C22.3824 13.6 21.9592 13.7882 21.395 13.7882Z"
        fill={fill[0]}
      />
      <path
        d="M33.5737 16H28.4013C26.7085 16 25.2979 14.5882 25.2979 12.8941V3.10588C25.2979 1.41176 26.7085 0 28.4013 0H33.5737C35.3135 0 36.6771 1.41176 36.6771 3.10588V12.9412C36.6771 14.6353 35.3135 16 33.5737 16Z"
        fill={fill[0]}
      />
      <path
        d="M31.3166 13.7883C31.2225 13.7883 31.1755 13.7883 31.0815 13.7883H27.6018V11.4824H31.4576C31.8338 11.4353 32.1159 11.153 32.163 10.8236C32.163 10.7765 32.163 10.7294 32.163 10.6353C32.163 9.7412 30.5642 9.12944 29.8589 8.51767V7.52944C30.5172 6.91767 32.163 6.25885 32.163 5.41179C32.163 5.36473 32.163 5.31767 32.163 5.22355C32.1159 4.89414 31.8338 4.61179 31.4576 4.56473H27.5548V2.30591H31.0344C31.1285 2.30591 31.2225 2.30591 31.2695 2.30591C31.3636 2.30591 31.4106 2.30591 31.5046 2.30591C32.8683 2.40003 34.0438 3.38826 34.326 4.70591C34.373 4.89414 34.373 5.08238 34.373 5.31767C34.373 6.30591 33.8557 7.24708 33.0093 7.81179L32.7272 8.04708L33.0093 8.28238C33.8557 8.84708 34.373 9.78826 34.373 10.7765C34.373 10.9647 34.373 11.2 34.326 11.3883C34.0438 12.7059 32.9153 13.6941 31.5046 13.7883C31.5046 13.7883 31.4106 13.7883 31.3166 13.7883Z"
        fill={fill[1]}
      />
      <path
        d="M42.4137 4.56473H40.7209V11.4353H42.4137V4.56473Z"
        fill={fill[0]}
      />
      <path
        d="M38.1282 7.16651V8.86063H44.9934V7.16651H38.1282Z"
        fill={fill[0]}
      />
    </svg>
  );
};
